import store from '../store/index'
import {BASIC_LOGIN, AD_AZURE_LOGIN, TWO_FA_LOGIN} from "../constants/LoginTypes"

export default class LoginUtil {

    static isLoggedIn() {
        let token = localStorage.getItem('token');
        return !!token;
    }

    static isBasicLoginType() {
        if (store) {
            return store.getters['app/getAppConfig'].loginType === BASIC_LOGIN;
        }
        if (!!localStorage.getItem('appConfig')) {
            let appConfig = JSON.parse(localStorage.getItem('appConfig'));
            return appConfig.loginType === BASIC_LOGIN;
        }
        return false;
    }

    static isADAzureLoginType() {
        if (store) {
            return store.getters['app/getAppConfig'].loginType === AD_AZURE_LOGIN;
        }
        if (!!localStorage.getItem('appConfig')) {
            let appConfig = JSON.parse(localStorage.getItem('appConfig'));
            return appConfig.loginType === AD_AZURE_LOGIN;
        }
        return false;
    }

    static isTwoFALoginType() {
        if (store) {
            return store.getters['app/getAppConfig'].loginType === TWO_FA_LOGIN;
        }
        if (!!localStorage.getItem('appConfig')) {
            let appConfig = JSON.parse(localStorage.getItem('appConfig'));
            return appConfig.loginType === TWO_FA_LOGIN;
        }
        return false;
    }
    static isDevLoginType() {
        if (!!localStorage.getItem('appConfig')) {
            let appConfig = JSON.parse(localStorage.getItem('appConfig'));
            if (appConfig.loginType == BASIC_LOGIN || appConfig.loginType == TWO_FA_LOGIN) {
                return true
            } else { 
                return false
            }
        }
    }
}
